export default {
      id: "archive-usage",
      viewBox: "0 0 60 60",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#archive",
      toString: function () {
        return this.url;
      }
    }